export const FLOW_DESIGNER_CLOSE = 'FLOW_DESIGNER_CLOSE';
export const closeFlowDesigner = () => ({
  type: FLOW_DESIGNER_CLOSE,
});

// In general, all flow designer (and so validations) state is bound to the workflow.
// E.g. Constants are defined at the flow level, as are endpoints, etc.
// This is intended to act as a reset as if the user refreshed browser, and double as memory cleanup when leaving:
export const FLOW_DESIGNER_LEAVE_WORKFLOW = 'FLOW_DESIGNER_LEAVE_WORKFLOW';
export const leaveWorkflow = () => ({
  type: FLOW_DESIGNER_LEAVE_WORKFLOW,
});

export const FLOW_SET_CANVAS_DIRTY = 'FLOW_SET_CANVAS_DIRTY';
export const setCanvasDirty = isDirty => ({
  type: FLOW_SET_CANVAS_DIRTY,
  payload: { isDirty },
});
